<fk-modal-base-container [title]="title" [footer]="modalFooter">
  <div class="fk-modal-content fk-change-password-modal fk-text">
    <div class="change-password-form" [formGroup]="changePasswordForm">
      <fk-form-control class="auth-dialog__content--form-control fk-mb4" [label]="'form.old-password.label' | translate" [control]="changePasswordForm.get('oldPassword')">
        <div class="fk-form-group">
          <input
            formControlName="oldPassword"
            class="fk-form-control"
            [type]="showPasswordOldPassword ? 'text' : 'password'"
            [placeholder]="'form.old-password.placeholder' | translate"
          />
          <button
            type="button"
            class="fk-form-group--suffix fk-btn fk-btn-ghost"
            [disabled]="changePasswordForm.disabled"
            (click)="showPasswordOldPassword = !showPasswordOldPassword"
          >
            <fk-icon
              [name]="showPasswordOldPassword ? 'eye' : 'eye-off'"
              [size]="20"
              [title]="(showPasswordOldPassword ? 'form.login.hidePassword' : 'form.login.showPassword') | translate | titlecase"
            ></fk-icon>
          </button>
        </div>
      </fk-form-control>

      <fk-form-control
        class="auth-dialog__content--form-control fk-mb4"
        [label]="'form.new-password.label' | translate"
        [control]="changePasswordForm.get('password')"
        [errorMessagesConfig]="errorMessagesConfig"
      >
        <div class="fk-form-group">
          <input
            formControlName="password"
            class="fk-form-control"
            [type]="showPassword ? 'text' : 'password'"
            [placeholder]="'form.password.placeholder' | translate"
          />
          <button
            type="button"
            class="fk-form-group--suffix fk-btn fk-btn-ghost"
            [disabled]="changePasswordForm.disabled"
            (click)="showPassword = !showPassword"
          >
            <fk-icon
              [name]="showPassword ? 'eye' : 'eye-off'"
              [size]="20"
              [title]="(showPassword ? 'form.login.hidePassword' : 'form.login.showPassword') | translate | titlecase"
            ></fk-icon>
          </button>
        </div>
      </fk-form-control>

      <fk-form-control
        class="auth-dialog__content--form-control fk-mb4"
        [label]="'form.confirm-password.label' | translate"
        [control]="changePasswordForm.get('confirmPassword')"
        [errorMessagesConfig]="errorMessagesConfig"
      >
        <div class="fk-form-group">
          <input
            formControlName="confirmPassword"
            class="fk-form-control"
            [type]="showPasswordRepeatPassword ? 'text' : 'password'"
            [placeholder]="'form.confirm-password.placeholder' | translate"
          />
          <button
            type="button"
            class="fk-form-group--suffix fk-btn fk-btn-ghost"
            [disabled]="changePasswordForm.disabled"
            (click)="showPasswordRepeatPassword = !showPasswordRepeatPassword"
          >
            <fk-icon
              [name]="showPasswordRepeatPassword ? 'eye' : 'eye-off'"
              [size]="20"
              [title]="(showPasswordRepeatPassword ? 'form.login.hidePassword' : 'form.login.showPassword') | translate | titlecase"
            ></fk-icon>
          </button>
        </div>
      </fk-form-control>
    </div>
  </div>
  <div class="fk-modal-content__rules-list">
    <div
      class="fk-modal-content__rules-list--item"
      [class.rule-failed]="!changePasswordForm.get('password').value || changePasswordForm.hasError('minlength', 'password')"
    >
      <div class="rule-icon">
        <fk-icon name="check" [size]="10"/>
      </div>
      <div class="rule-text" [innerHTML]="'auth.change-password.rules.rule1' | translate"></div>
    </div>
    <div
      class="fk-modal-content__rules-list--item"
      [class.rule-failed]="!changePasswordForm.get('password').value || changePasswordForm.hasError('hasCapitalCase', 'password')"
    >
      <div class="rule-icon">
        <fk-icon name="check" [size]="10"/>
      </div>
      <div class="rule-text" [innerHTML]="'auth.change-password.rules.rule2' | translate"></div>
    </div>
    <div
      class="fk-modal-content__rules-list--item"
      [class.rule-failed]="!changePasswordForm.get('password').value || changePasswordForm.hasError('hasNumber', 'password')"
    >
      <div class="rule-icon">
        <fk-icon name="check" [size]="10"/>
      </div>
      <div class="rule-text" [innerHTML]="'auth.change-password.rules.rule3' | translate"></div>
    </div>
    <div
      class="fk-modal-content__rules-list--item"
      [class.rule-failed]="!changePasswordForm.get('password').value || changePasswordForm.hasError('hasSpecialCharacter', 'password')"
    >
      <div class="rule-icon">
        <fk-icon name="check" [size]="10"/>
      </div>
      <div class="rule-text" [innerHTML]="'auth.change-password.rules.rule4' | translate"></div>
    </div>
  </div>
</fk-modal-base-container>

<ng-template #modalFooter>
  <div class="fk-modal-container__footer-content">
    <button
      (click)="onCloseModal()"
      class="fk-btn fk-btn-tertiary fk-btn-medium"
    >{{ 'cancel' | translate }}</button>
    <button
      class="fk-btn fk-btn-dark fk-btn-medium"
      [disabled]="changePasswordForm.invalid"
      (click)="updatePassword()"
    >{{ 'auth.change-password.submit' | translate }}</button>
  </div>
</ng-template>
